import React, { useEffect, useState, useContext } from "react";
import projectsService from "../../services/api/projects-service";
import creditService from '../../services/api/genai-credits-service';
import { useHistory } from "react-router-dom";
// import ReactDatetime from 'react-datetime';
import moment from 'moment';
import UserContext from "../../UserContext";


import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Label,
  FormGroup,
  Form,
  Input,
  Alert,
  Spinner,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
} from "reactstrap";

import Select from "react-select";

const Create = (props) => {
  const history = new useHistory();
  const [formdetails, setFormDetails] = useState({ publisher_id: '', project_id: '', total_quota: 0, daily_quota:300 });
  const [projectstate, setProjectState] = useState("");
  const [projecterror, setProjectError] = useState("");
  const [publisherstate, setPublisherState] = useState("");
  const [publishererror, setPublisherError] = useState("");
  const [startDateState, setStartDateState] = useState("");
  const [startDateError, setStartDateError] = useState("");
  const [endDateState, setEndDateState] = useState("");
  const [endDateError, setEndDateError] = useState("");
  const [totalQuotaState, setTotalQuotaState] = useState("");
  const [totalQuotaError, setTotalQuotaError] = useState("");
  const [publisher, setPublisher] = useState('');
  const [publisherFieldValue, setPublisherFieldValue] = useState('');
  const [projectFieldValue, setProjectFieldValue] = useState('');
  const [allProjects, setAllProjects] = useState([]);
  const [allPublishers, setAllPublishers] = useState([]);

  const [totalQuota, setTotalQuotaValue] = useState('');


  const [dailyQuota, setDailyQuotaValue] = useState('');
  const [dailyQuotaState, setDailyQuotaState] = useState("");
  const [dailyQuotaError, setDailyQuotaError] = useState("");

  const [showLoader, setShowLoader] = useState(false);
  const [showSaveButton, setShowSaveButton] = useState(true);
  const [alert, setAlert] = useState({ show: false, message: '', type: '' });
  const context = useContext(UserContext);
  useEffect(() => {
    (async () => {
      if (publisher) {
        let projects = await projectsService.getPublisherProjects(publisher);
        let publisherProjects = [];
        if (projects.status) {
          let projectData = projects.data;
          if (projectData.length) {
            projectData.forEach(function (projectDetails) {
              let projectValue = { value: projectDetails.id, label: `${projectDetails.name} (${projectDetails.slug})` };
              publisherProjects.push(projectValue)
            })
          }
          setAllProjects(publisherProjects);
        }
      }
    })();
  }, [publisher]);

  // useEffect(()=>{
  //   (async()=>{
  //     let transactionList = await creditService.getUnmappedTransactionList();
  //     if(transactionList.status){
  //       let getTransactions = [];
  //       let transactionData = transactionList.data;
  //       if(transactionData.length){
  //         transactionData.forEach(function(transactionDetails){
  //           let transactionValue = {value:transactionDetails.pg_txn_id,label:(transactionDetails.amount)/100+"("+transactionDetails.pg_txn_id+")"};
  //           getTransactions.push(transactionValue);
  //         })
  //         setAllTransactiion(getTransactions);
  //       }
  //     }
  //   })();
  // },[])

  useEffect(() => {
    (async () => {
      let publishers = await projectsService.getAllPublishers();
      if (publishers.status) {
        let getPublishers = [];
        let publisherData = publishers.data;
        if (publisherData.length) {
          publisherData.forEach(function (publisherDetails) {
            let publisherValue = { value: publisherDetails.id, label: publisherDetails.name + "(" + publisherDetails.email + ")", email: publisherDetails.email };
            getPublishers.push(publisherValue)
          })
        }
        setAllPublishers(getPublishers);
      }
      setDailyQuotaValue(formdetails.daily_quota)
    })();
  }, []);

  const changePublisher = (event) => {
    setFormDetails({
      ...formdetails,
      publisher_id: event.value,
      project_id: ''
    });
    setProjectFieldValue('');
    setPublisher(event.value);
    setPublisherFieldValue(event);
    setPublisherState("");
    setPublisherError("");
  }

  const changeProject = (event) => {
    setFormDetails({
      ...formdetails,
      project_id: event.value,
    });
    setProjectFieldValue(event);
    setProjectState("");
    setProjectError("");
  }

  const changeQuota = (value) => {
    setFormDetails({
      ...formdetails,
      total_quota: value,
    });
    setTotalQuotaValue(value);
    setTotalQuotaState("");
    setTotalQuotaError("");
  }

  const changeDailyQuota = (value) => {
    setFormDetails({
      ...formdetails,
      daily_quota: value,
    });
    setDailyQuotaValue(value);
    setDailyQuotaState("");
    setDailyQuotaError("");
  }


  const validateFields = () => {
    let validations = true;
    if (formdetails.publisher_id === '') {
      setPublisherState("has-danger");
      setPublisherError("Please select a publisher.");
      validations = false;
    }

    if (formdetails.project_id === '') {
      setProjectState("has-danger");
      setProjectError("Please select a project.");
      validations = false;
    }

    if (!formdetails.total_quota) {
      setTotalQuotaState("has-danger");
      setTotalQuotaError("Please enter the total number of credits to assign.");
      validations = false;
    } else if (isNaN(formdetails.total_quota) || formdetails.total_quota <= 0) {
      setTotalQuotaState("has-danger");
      setTotalQuotaError("Please enter a valid positive number for total credits.");
      validations = false;
    }

    if (!formdetails.daily_quota) {
      setDailyQuotaState("has-danger");
      setDailyQuotaError("Please enter the daily quota limit.");
      validations = false;
    } else if (isNaN(formdetails.daily_quota) || formdetails.daily_quota <= 0) {
      setDailyQuotaState("has-danger");
      setDailyQuotaError("Please enter a valid positive number for the daily quota.");
      validations = false;
      console.log("failed validation")
    }

    // if(formdetails.start_date===''){
    //     setStartDateState("has-danger");
    //     setStartDateError("This field is required");
    //     validations = false;
    // }

    // if(formdetails.expire_date===''){
    //     setEndDateState("has-danger");
    //     setEndDateError("This field is required");
    //     validations = false;
    // }
    // if(formdetails.start_date && formdetails.expire_date && moment(formdetails.expire_date).isBefore(formdetails.start_date)){
    //     setStartDateState("has-danger");
    //     setStartDateError("Start date should be less than expire date");
    //     validations = false;
    // }
    return validations;
  }


  const handleSubmit = function (e) { validateForm(); e.preventDefault() }

  const validateForm = async () => {
    let validated = validateFields();
    if (validated) {
      setShowLoader(true);
      setShowSaveButton(false);
      let createContract = await creditService.assignCredits(formdetails);
      if (!createContract.status && createContract.error.errorCode === 403) {
        context.setIsAuthorized(context);
      }
      else if (createContract.status) {
        setTimeout(() => {
          setShowLoader(false)
          setAlert({ show: true, type: 'success', message: 'GenAI Apis credit was assigned Successfully' });
        }, 1000);

        setTimeout(() => {
          setAlert({ show: false, type: '', message: '' });
        }, 3000);

        setTimeout(() => {
          history.push("/genai/credits");
        }, 2000);

      } else {
        setTimeout(() => {
          setShowLoader(false)
          setShowSaveButton(true)
          setAlert({ show: true, type: 'danger', message: 'GenAI Api credits could not be assigned, Please try again.' });
        }, 1000);

        setTimeout(() => {
          setAlert({ show: false, type: '', message: '' });
        }, 3000);
      }
    }
  }

  const redirectUrl = (event) => {
    event.preventDefault();
    history.push("/genai/credits")
  }

  const disablePastDates = (current) => {
    const previousDate = moment().subtract(1, 'day');
    return current.isAfter(previousDate);
  }
  const disablePastDatesForEndDate = (current) => {
    const previousDate = moment(formdetails.start_date).subtract(1, "day");
    return current.isAfter(previousDate);
  };
  const disablePastAndPreviousDatesForStartDate = (current) => {
    const previousDate = moment(formdetails.expire_date)
    return current.isBetween(moment(), previousDate);
  };

  const handleStartDateChange = (event) => {
    setFormDetails({
      ...formdetails,
      start_date: moment(event._d)
    });
    setStartDateError("");
    setStartDateState("");
  }

  const handleEndDateChange = (event) => {
    setFormDetails({
      ...formdetails,
      expire_date: moment(event._d)
    });
    setEndDateError("");
    setEndDateState("");
  }

  return (
    <div className="content">
      <Container>
        <Row>
          <Col className="ml-auto mr-auto" md="12">
            <Card className="card-signup text-center">
              <CardHeader>
                <CardTitle tag="h4">Assign GenAI Api Credits</CardTitle>
              </CardHeader>
              <CardBody>
                <Form className="form-horizontol" action="" id="createContract" method="POST" onSubmit={handleSubmit}>

                  <Row>
                    <Label className="bold" sm="2">Select Publisher <span class="text-danger"> * </span></Label>
                    <Col sm="7">
                      <FormGroup className={publisherstate}>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          name="publisherid"
                          value={publisherFieldValue}
                          onChange={changePublisher}
                          options={allPublishers}
                        />

                        {publisherstate === "has-danger" ? (
                          <label className="error">
                            {publishererror}
                          </label>
                        ) : null}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Label className="bold" sm="2">Select Project <span class="text-danger"> * </span></Label>
                    <Col sm="7">
                      <FormGroup className={projectstate}>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          name="publisherid"
                          value={projectFieldValue}
                          onChange={changeProject}
                          options={allProjects}
                        />

                        {projectstate === "has-danger" ? (
                          <label className="error">
                            {projecterror}
                          </label>
                        ) : null}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Label className="bold" sm="2">Total Credits <span class="text-danger"> * </span></Label>
                    <Col sm="7">
                      <FormGroup className={totalQuotaState}>
                        <Input
                          type="number"
                          id="totalQuota"
                          min='1'
                          value={totalQuota}
                          onChange={(e) => changeQuota(e.target.value)}
                          required
                        />
                        {totalQuotaState === "has-danger" ? (
                          <label className="error">
                            {totalQuotaError}
                          </label>
                        ) : null}
                      </FormGroup>
                    </Col>
                  </Row>

                  <Row>
                    <Label className="bold" sm="2">Daily Quota <span class="text-danger"> * </span></Label>
                    <Col sm="7">
                      <FormGroup className={dailyQuotaState}>
                        <Input
                          type="number"
                          id="dailyQuota"
                          min='1'
                          value={dailyQuota}
                          onChange={(e) => changeDailyQuota(e.target.value)}
                          required
                        />

                        {dailyQuotaState === "has-danger" ? (
                          <label className="error">
                            {dailyQuotaError}
                          </label>
                        ) : null}
                      </FormGroup>
                    </Col>
                  </Row>



                  {/* <Row>
                        <Label className="bold" sm="2">Start Date <span class="text-danger"> * </span></Label>
                        <Col sm="7">
                            <FormGroup className={startDateState}>
                                    <ReactDatetime
                                        value={formdetails.start_date}
                                        name="start_date"
                                        isValidDate={ formdetails.expire_date?disablePastAndPreviousDatesForStartDate:disablePastDates}
                                        onChange={handleStartDateChange}
                                        dateFormat ={"DD/MM/YYYY"}
                                        closeOnSelect
                                    />
                                    {startDateState === "has-danger" ? (
                            <label className="error">
                            {startDateError}
                            </label>
                        ) : null}
                            
                            </FormGroup>
                            </Col>
                    </Row>

                    <Row>
                        <Label className="bold" sm="2">End Date <span class="text-danger"> * </span></Label>
                        <Col sm="7">
                            <FormGroup className={endDateState}>
                                <ReactDatetime
                                    value={formdetails.expire_date}
                                    name="end_date"
                                    // id="scheduleTime"
                                    isValidDate={ formdetails.start_date?disablePastDatesForEndDate:disablePastDates}
                                    onChange={handleEndDateChange}
                                    dateFormat ={"DD/MM/YYYY"}
                                    closeOnSelect
                                />
                                {endDateState === "has-danger" ? (
                                  <label className="error">
                                  {endDateError}
                                  </label>
                                ) : null}
                            
                            </FormGroup>
                        </Col>
                    </Row> */}



                  {showSaveButton ? <span>
                    <Button
                      className="btn-round"
                      color="info"
                      type="button"
                      onClick={validateForm}
                    >
                      Create
                    </Button>

                    <Button
                      className="btn-round"
                      color="warning"
                      type="button"
                      onClick={redirectUrl}
                    >
                      Cancel
                    </Button>

                  </span> : ''}
                  {alert.show ? <Alert color={alert.type}>
                    {alert.message}
                  </Alert> : ''}

                  {showLoader ? <Spinner animation="border" role="status">
                    <span className="sr-only">Loading...</span>
                  </Spinner> : ''}

                </Form>
              </CardBody>
              <CardFooter>

              </CardFooter>
            </Card>
          </Col>
        </Row>
      </Container>
      <div
        className="full-page-background"
        style={{
          backgroundImage: `url(${require("../../assets/img/bg/jan-sendereks.jpg")})`,
        }}
      />
    </div>
  );

}

export default Create;
